<section class="is-flex is-space-between" *ngIf="vm$ | async as vm">

  <div class="is-flex gap-8">
    <app-icon [name]="RoomsAssets[vm.roomType]?.icon ?? ICONS[vm.card.graphType]" class="text-32"></app-icon>
    <app-text class="text-14 is-family-semiBold">{{ LABELS[vm.card.graphType] | LANG }}</app-text>
    <ng-container *ngIf="vm.roomName">
      <app-text>-</app-text>
      <app-text class="text-14 is-family-semiBold">{{ vm.roomName }}</app-text>
    </ng-container>
  </div>
  <div class="is-flex">

    <app-control-page-graph-module-selector></app-control-page-graph-module-selector>
    <app-data-management></app-data-management>

  </div>


</section>
